import { render, staticRenderFns } from "./CmgNutritionCalculatorMealBuilderPage.vue?vue&type=template&id=6c0db474&scoped=true&lang=pug&"
import script from "./cmg-nutrition-calculator-meal-builder-page.ts?vue&type=script&lang=ts&"
export * from "./cmg-nutrition-calculator-meal-builder-page.ts?vue&type=script&lang=ts&"
import style0 from "./CmgNutritionCalculatorMealBuilderPage.vue?vue&type=style&index=0&id=6c0db474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0db474",
  null
  
)

export default component.exports